export enum Representation {
  //representationOptions
  isLawyer = 1,
  isAssociation = 2,
  noLawyerOrAssociation = 3,
}
